var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdownstop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5479 20.4072C18.5479 20.0557 18.3105 19.8096 17.9678 19.8096H12.1055C12.2285 19.7832 12.3428 19.7217 12.4395 19.6162L18.3633 13.7012C18.4951 13.5693 18.5479 13.4287 18.5479 13.2705C18.5479 12.9365 18.3018 12.6816 17.9766 12.6816C17.8184 12.6816 17.6602 12.7432 17.5547 12.8486L14.9004 15.4766L12.5361 18.0342L12.5889 16.1445V3.92773C12.5889 3.58496 12.3428 3.33887 12 3.33887C11.6484 3.33887 11.4023 3.58496 11.4023 3.92773V16.1445L11.4639 18.0254L9.09961 15.4766L6.43652 12.8486C6.33984 12.7432 6.17285 12.6816 6.01465 12.6816C5.68945 12.6816 5.44336 12.9365 5.44336 13.2705C5.44336 13.4287 5.50488 13.5693 5.62793 13.7012L11.5518 19.6162C11.6484 19.7217 11.7627 19.7832 11.8857 19.8096H6.03223C5.68945 19.8096 5.44336 20.0557 5.44336 20.4072C5.44336 20.75 5.68945 20.9961 6.03223 20.9961H17.9678C18.3105 20.9961 18.5479 20.75 18.5479 20.4072Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdownstop);
export default __webpack_public_path__ + "static/media/Arrow down stop.4b0fa4623c5eee74cd009a93a890958a.svg";
export { ForwardRef as ReactComponent };